import React from 'react';
const Copyright = ({ saleItemList }) => {
    return (React.createElement("div", null,
        React.createElement("div", { className: "copyright mt-12" }, "\u00A9 2021 Valve Corporation. Steam and the Steam logo are trademarks and/or registered trademarks of Valve Corporation in the U.S. and/or other countries."),
        React.createElement("div", { className: "copyright mt-3 sm:pb-6" }, saleItemList.map((saleItem, idx) => {
            return `${saleItem.copyright} `;
        }))));
};
export default Copyright;
